import { render, staticRenderFns } from "./LmMenu.vue?vue&type=template&id=cb84ecf0&scoped=true&"
import script from "./LmMenu.vue?vue&type=script&lang=js&"
export * from "./LmMenu.vue?vue&type=script&lang=js&"
import style0 from "./LmMenu.vue?vue&type=style&index=0&id=cb84ecf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb84ecf0",
  null
  
)

export default component.exports